import React, { useState } from "react";
import { apiFetch } from "../utils/api";
import AuthLayout from "../components/AuthLayout";
import { IconWarning } from "../components/ui/icons";

export default function SelectDatabase({ user, onSelected }) {
  const [loadingId, setLoadingId] = useState(null);
  const [errorMsg, setErrorMsg] = useState("");

  const handleSelect = async (id) => {
    setLoadingId(id);
    setErrorMsg("");
    try {
      const res = await apiFetch("/select_db.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });
      const data = await res.json();
      if (data.success) {
        onSelected();
      } else {
        setErrorMsg(data.error || "Greška pri izboru baze.");
      }
    } catch {
      setErrorMsg("Neuspešna konekcija sa serverom.");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <AuthLayout>
      <h1 className="text-lg font-semibold text-slate-900 dark:text-slate-50">Izaberi firmu</h1>
      <p className="mb-5 mt-0.5 text-sm text-slate-500 dark:text-slate-400">
        {user?.firstname ? `Zdravo, ${user.firstname}. ` : ""}Imaš pristup na više lokacija.
      </p>

      <div className="flex flex-col gap-2">
        {(user?.databases || []).map((db) => (
          <button
            key={db.id}
            type="button"
            onClick={() => handleSelect(db.id)}
            disabled={loadingId !== null}
            className="flex h-11 items-center justify-between rounded-md border border-slate-300 px-3.5 text-left text-sm font-medium text-slate-800
              transition duration-150 hover:border-primary hover:bg-primary/5 active:translate-y-px disabled:pointer-events-none disabled:opacity-50
              dark:border-slate-700 dark:text-slate-100 dark:hover:border-primary-light dark:hover:bg-primary/10"
          >
            <span className="truncate">{db.label}</span>
            {loadingId === db.id && <span className="text-xs font-normal text-slate-500 dark:text-slate-400">Učitavanje...</span>}
          </button>
        ))}
      </div>

      {errorMsg && (
        <p role="alert" className="mt-4 flex items-start gap-2 rounded-md border border-danger/30 bg-danger/5 px-3 py-2 text-sm text-danger-dark dark:text-danger-light">
          <IconWarning aria-hidden="true" className="mt-0.5 shrink-0 text-base" />
          {errorMsg}
        </p>
      )}
    </AuthLayout>
  );
}
